import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  debounce,
  IconButton,
  Tooltip,
} from "@mui/material";
import NotificationData from "./NotificationData";
import moment from "moment";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { notificationMarkAsReadAll } from "../../../api/notificationMarkAsReadAll";
import { deleteNotificationAll } from "../../../api/deleteNotificationAll";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function getMyText(date) {
  // if (!moment.isMoment(date)) {
  let dateM = moment(date);
  // }


  if (dateM.isSame(moment(), "day")) {
    return "Today";
  } else if (dateM.isSame(moment().subtract(1, "d"), "day")) {
    return "Yesterday";
  } else if (dateM.isSame(moment(), "week")) {
    return dateM.format("dddd");
  } else {
    return dateM.format("MMM DD");
  }
}

const NotificationComponent = ({ data }) => {
  // return data.map((noti) => <div>{noti.message_text}</div>);

  const userId = useSelector((state) => state.loggedUser.user.id);
  const token = useSelector((state) => state.auth.token);

  const handleMarkAsReadAll = async (id) => {
    try {
      if (token && id) {
        const data = await notificationMarkAsReadAll(id, token);
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error("no user id");
      }
    } catch (error) {
      toast.error("error !!");
    }
  };

  const handleDeleteAll = async (id) => {
    try {
      if (token && id) {
        const data = await deleteNotificationAll(id, token);
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      toast.error("error !!");
    }
  };

  // "";

  return (
    <>
      <Box className="leader-board-main">
        <Box className="leader-board-wrapper">
          <Box className="heading" sx={{ display: "flex" }}>
            <Typography component="h1" sx={{ flexGrow: "1" }}>
              NOTIFICATION
            </Typography>
            <Box className="options">
              <IconButton
                onClick={() => {
                  if (data.filter((noti) => !noti.is_read).length > 0) {
                    userId && handleMarkAsReadAll(userId);
                  } else {
                    toast.error("No Notifications!!");
                  }
                }}
              >
                <Tooltip title="Mark as Read All" placement="top">
                  <DoneAllIcon sx={{ color: "white" }} />
                </Tooltip>
              </IconButton>
              <IconButton
                onClick={() => {
                  if (userId && data.length > 0) {
                    userId && handleDeleteAll(userId);
                  } else {
                    toast.error("No Notifications!!");
                  }
                }}
              >
                <Tooltip title="Delete All" placement="top">
                  {/* <ClearAllIcon sx={{ color: "white" }} /> */}
                  <DeleteForeverIcon sx={{ color: "white" }} />
                </Tooltip>
              </IconButton>
            </Box>
          </Box>
          <Box className="notifications-main">
            {data.map((notification, i) => {
              let dateChanged = false;
              const c = data[i - 1]?.createdAt;
              const d = data[i].createdAt;
              if (i >= 1) {
                // console.log(
                //   moment(c).isSame(d, "day"),
                //   c,
                //   d,
                //   " lksadfjlksdfjlkd"
                // );
                if (moment(c).isSame(d, "day")) {
                  dateChanged = false;
                } else {
                  dateChanged = true;
                }
              }
              return (
                <>
                  {i == 0 ? (
                    <Box className="date">
                      {getMyText(notification.createdAt)}
                    </Box>
                  ) : (
                    ""
                  )}
                  {dateChanged ? (
                    <Box className="date">
                      {getMyText(notification.createdAt)}
                    </Box>
                  ) : (
                    ""
                  )}
                  <NotificationData data={notification} />
                </>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default NotificationComponent;
